import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TutorialStep } from "@/components/auth/onboarding/TutorialStep";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

const Tutorial = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [searchParams] = useSearchParams();
  const isOnboarding = searchParams.get("onboarding") === "true";

  const handleComplete = () => {
    console.log("[Tutorial] Tutorial complete, isOnboarding:", isOnboarding);
    // Check if we're in onboarding flow
    if (isOnboarding) {
      // After tutorial in onboarding, mark as complete and go to dashboard
      // Pro upsell will be shown on third AI quick entry button press
      console.log("[Tutorial] Onboarding tutorial complete - marking onboarding complete");
      localStorage.setItem("onboarding_complete", "true");
      navigate("/", { replace: true });
    } else {
      // Normal tutorial from dashboard, just navigate back
      console.log("[Tutorial] Not in onboarding, returning to dashboard");
      navigate("/");
    }
  };

  const handleClose = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header with close button - only show if not in onboarding and not on mobile */}
      {!isOnboarding && !isMobile && (
        <div className="flex justify-between items-center p-4 border-b flex-shrink-0 mt-12 sm:mt-16">
          <h1 className="text-lg font-semibold">{t('tutorial_page.title')}</h1>
          <Button variant="ghost" size="icon" onClick={handleClose}>
            <X className="h-5 w-5" />
          </Button>
        </div>
      )}

      {/* Tutorial content - fills remaining space */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <TutorialStep onComplete={handleComplete} />
      </div>
    </div>
  );
};

export default Tutorial;
